import { api, queryClient } from "@/utils/api";
import { mutationOptions, queryOptions } from "@tanstack/react-query";
import { appConfigurationQueryOptions } from "./app-configuration.api";

export type CreditsResponse = {
  baseCreditsPerMonth: number;
  extraCreditsPerMonth: number;
  extraCreditsPerMonthPrice: number;
  creditsRemaining: number;
  creditsBuffer: number;
  creditEstimate: number;
  creditEstimateNextPeriod: number;
  creditEstimateRestOfPeriod: number;
  creditsRenewalDate: string | null;
};

export const creditsApi = {
  get: async () => api.get("apps/sales/credits").json<CreditsResponse>(),
};

// Update the app configuration cache with the new credits info
const updateAppConfigurationCacheCredits = (credits: CreditsResponse) =>
  queryClient.setQueryData(
    appConfigurationQueryOptions.queryKey,
    (prev) =>
      prev && {
        ...prev,
        ...credits,
      },
  );

export const getCreditsMutationOptions = mutationOptions({
  mutationFn: async () => {
    const credits = await creditsApi.get();
    queryClient.setQueryData(creditsQueryOptions.queryKey, credits);
    updateAppConfigurationCacheCredits(credits);
    return credits;
  },
});

export const creditsQueryOptions = queryOptions({
  queryKey: ["credits"],
  queryFn: async () => {
    const credits = await creditsApi.get();
    updateAppConfigurationCacheCredits(credits);
    return credits;
  },
  staleTime: 5 * 60 * 1000, // 5 minutes
});

export const getCreditsFromCache = () =>
  queryClient.getQueryData(creditsQueryOptions.queryKey);
